import { Box } from '@mui/material';
import React from 'react';
import TeacherDashboard from './TeacherDasboard';
function Teacher() {
    return (
      <Box>
      <TeacherDashboard/>
    </Box>
  );
}

export default Teacher;
